(() => {
  'use strict';
  if (window.wppoPurchaseReady) return;
  window.wppoPurchaseReady = true;
  const root = () => window.Shopify?.routes?.root || '/';
  const pending = new WeakSet();
  let cartWritePending = false;
  function enhanceCatalog() {
    document.querySelectorAll('main a[href^="/cart/"]').forEach(anchor => {
      const match = anchor.getAttribute('href').match(/^\/cart\/(\d+):1$/);
      if (!match || anchor.closest('form')) return;
      const name = (anchor.getAttribute('aria-label') || anchor.textContent).replace(/^Buy\s+|\s+now$/gi, '');
      const form = document.createElement('form');
      form.method = 'post';
      form.action = root() + 'cart/add';
      form.className = 'wppo-purchase';
      form.dataset.wppoPurchase = '';
      form.innerHTML = '<input type="hidden" name="id"><label class="wppo-purchase__quantity">Qty<input type="number" name="quantity" value="1" min="1" step="1" inputmode="numeric" required></label><div class="wppo-purchase__actions"><button type="submit" name="return_to" class="wppo-purchase__add">Add to cart</button><button type="submit" name="return_to" class="wppo-purchase__buy">Buy now</button></div><p class="wppo-purchase__status" role="status" aria-live="polite"></p>';
      form.elements.id.value = match[1];
      form.elements.quantity.setAttribute('aria-label', 'Quantity for ' + name);
      const buttons = form.querySelectorAll('button');
      buttons[0].value = root() + 'cart';
      buttons[0].setAttribute('aria-label', 'Add ' + name + ' to cart');
      buttons[1].value = root() + 'checkout';
      buttons[1].setAttribute('aria-label', 'Buy ' + name + ' now');
      anchor.replaceWith(form);
    });
  }
  const message = (target, text, error = false, link = false) => {
    if (!target) return;
    target.replaceChildren(document.createTextNode(text));
    target.toggleAttribute('data-error', error);
    if (link) {
      const anchor = document.createElement('a');
      anchor.href = root() + 'cart';
      anchor.textContent = 'View cart';
      target.append(document.createTextNode(' '), anchor);
    }
  };
  async function add(form, button, checkout, native = false) {
    if (pending.has(form)) return;
    const status = form.querySelector('.wppo-purchase__status');
    if (cartWritePending) {
      message(status, 'Please wait for the previous item to finish adding.');
      return;
    }
    if (!form.reportValidity()) return;
    const nativeSubmit = native && form.querySelector('[name="add"]');
    if (nativeSubmit && (nativeSubmit.disabled || nativeSubmit.getAttribute('aria-disabled') === 'true')) return;
    const body = new FormData(form);
    if (!body.get('id')) return;
    body.delete('return_to');
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    if (!checkout && cart?.getSectionsToRender) {
      body.set('sections', cart.getSectionsToRender().map(s => s.id).join(','));
      body.set('sections_url', window.location.pathname);
      cart.setActiveElement?.(button);
    }
    const buttons = Array.from(form.querySelectorAll('button'));
    const oldDisabled = buttons.map(b => b.disabled);
    const originalText = button.textContent;
    pending.add(form);
    cartWritePending = true;
    buttons.forEach(b => { b.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    button.textContent = checkout ? 'Opening checkout…' : 'Adding…';
    message(status, '');
    let added = false;
    try {
      const response = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : 'This item could not be added. Please check the selected option and quantity.');
      added = true;
      if (checkout) {
        window.location.assign(root() + 'checkout');
        return;
      }
      message(status, 'Added to cart. Keep shopping or', false, true);
      try {
        if (cart?.renderContents && result.sections) cart.renderContents(result);
        else {
          const cartResponse = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
          if (cartResponse.ok) {
            const current = await cartResponse.json();
            const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
            if (bubble) {
              const spans = bubble.querySelectorAll('span');
              if (spans[0]) spans[0].textContent = String(current.item_count);
              if (spans[1]) spans[1].textContent = `${current.item_count} items`;
            }
          }
        }
      } catch (_) { /* Item is already added; keep the direct cart link available. */ }
    } catch (error) {
      // Never retry an uncertain cart write: a retry could add duplicate units.
      message(status, added ? 'Added to cart. Continue in your cart.' : 'Could not confirm this addition. Check your cart before trying again. ' + error.message, true, true);
    } finally {
      pending.delete(form);
      cartWritePending = false;
      buttons.forEach((b, i) => { b.disabled = oldDisabled[i]; });
      form.removeAttribute('aria-busy');
      button.textContent = originalText;
      syncNative(form);
    }
  }
  function syncNative(scope = document) {
    scope.querySelectorAll('[data-wppo-buy-now]').forEach(button => {
      const form = button.closest('form');
      if (pending.has(form)) return;
      const submit = form?.querySelector('[name="add"]');
      const disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true' || !form.querySelector('[name="id"]')?.value;
      if (button.disabled !== disabled) button.disabled = disabled;
    });
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('form[data-wppo-purchase]')) return;
    event.preventDefault();
    const button = event.submitter || form.querySelector('.wppo-purchase__add');
    add(form, button, button?.value.endsWith('checkout'));
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-wppo-buy-now]');
    if (!button || button.disabled) return;
    event.preventDefault();
    add(button.closest('form'), button, true, true);
  });
  const observer = new MutationObserver(() => syncNative());
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
  syncNative();
  enhanceCatalog();
  document.addEventListener('shopify:section:load', enhanceCatalog);
})();
